import { STATUS } from "@/lib/format";

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS[status];
  if (!s) return <span className="text-xs text-muted-foreground">–</span>;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.bar}`} />
      {s.label}
    </span>
  );
};
